const addresses = {
  /* eslint-disable @typescript-eslint/naming-convention */
  RONRegistrarControllerLogic: {
    "2021": "0x512699b52ac2dc2b2ad505d9f29dcdad078fa799",
    "2020": "0x662852853614cbbb5d04bf2e29955b97e3c50b69"
  },
  Multicall: {
    "2021": "0x31c9ef8a631e2489e69833df3b2cb4bf0dc413bc",
    "2020": "0xc76d0d0d3aa608190f78db02bf2f5aef374fc0b9"
  },
  PublicResolverLogic: {
    "2021": "0x803c459dcb8771e5354d1fc567ecc6885a9fd5e6",
    "2020": "0xadb077d236d9e81fb24b96ae9cb8089ab9942d48"
  },
  RNSUnifiedLogic: {
    "2021": "0xf0c99c9677eda0d13291c093b27e6512e4acdf83",
    "2020": "0x67c409dab0ee741a1b1be874bd1333234cfdbf44"
  },
  ReverseRegistrarLogic: {
    "2021": "0x0cc07f120dffdf507a6e983c54bcb402fc6bf716",
    "2020": "0xb8618a73cc08d2c4097d5c0e0f32fa4af4547e2f"
  },
  RNSDomainPriceLogic: {
    "2021": "0x51caf51678f469e9dd4c878a7b0cebebbd4a4ab5",
    "2020": "0x2bdc555a87db9207e5d175f0c12b237736181675"
  }
  /* eslint-enable @typescript-eslint/naming-convention */
};

const getContractAddress = networkId => contractName => {
  try {
    return typeof addresses[contractName] === "string" ? addresses[contractName] : addresses[contractName][networkId];
  } catch (_a) {
    throw new Error(`No address for contract ${contractName} on network ${networkId}`);
  }
};

export { addresses, getContractAddress };
